function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';

var PlotCheckboxList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PlotCheckboxList, _React$Component);

  function PlotCheckboxList() {
    _classCallCheck(this, PlotCheckboxList);

    return _possibleConstructorReturn(this, _getPrototypeOf(PlotCheckboxList).apply(this, arguments));
  }

  _createClass(PlotCheckboxList, [{
    key: "onCheckboxChangeGenerator",
    value: function onCheckboxChangeGenerator(plotCheckboxId) {
      var _this = this;

      return function () {
        _this.props.plotCheckboxChanged(plotCheckboxId, !_this.props.plotCheckboxes[plotCheckboxId]);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", null, this.props.plotDataTypes.map(function (dataType) {
        return React.createElement("div", {
          className: "cndc-checkbox-list",
          key: "".concat(_this2.props.plotSectionId, "-checkbox-list-").concat(dataType.id)
        }, React.createElement("div", {
          className: "cndc-checkbox-wrapper"
        }, React.createElement("label", {
          className: "checkbox-inline cndc-checkbox-label",
          htmlFor: "".concat(_this2.props.plotSectionId, "-checkbox-").concat(dataType.id)
        }, React.createElement("input", {
          type: "checkbox",
          className: "cndc-checkbox checkbox-replaced",
          id: "".concat(_this2.props.plotSectionId, "-checkbox-").concat(dataType.id),
          checked: _this2.props.plotCheckboxes[dataType.id],
          onChange: _this2.onCheckboxChangeGenerator(dataType.id)
        }), dataType.name, React.createElement("label", {
          className: "checkbox-replacement checkbox-replacement--colored",
          htmlFor: "".concat(_this2.props.plotSectionId, "-checkbox-").concat(dataType.id),
          style: {
            backgroundColor: dataType.color
          }
        }))));
      }));
    }
  }]);

  return PlotCheckboxList;
}(React.Component);

PlotCheckboxList.propTypes = {
  plotSectionId: PropTypes.string.isRequired,
  plotDataTypes: PropTypes.array.isRequired,
  plotCheckboxes: PropTypes.object.isRequired,
  plotCheckboxChanged: PropTypes.func.isRequired
};
export { PlotCheckboxList as default };